export const DD_MARKETING_PAGE_URL =
  "https://www.ebsco.com/health-care/products/dynamed-decisions";
export const MHD_MARKETING_PAGE_URL =
  "https://www.ebsco.com/health-care/products/my-health-decisions";
export const TERMS_OF_USE_URL =
  "https://resources.ebsco.zone/ebsco-policies/terms-of-use.md";
